/*!
 * Drag-scroll — face orice container cu `overflow-x` tras cu mouse-ul.
 *
 * Pe touch scroll-ul orizontal exista deja nativ; lipsea doar la mouse, unde
 * utilizatorul vede un carusel dar nu il poate trage.
 *
 * Se activeaza pe `[data-drag-scroll]`. Atributul opțional
 * `data-drag-scroll-until="749"` limiteaza comportamentul la lățimi mai mici sau
 * egale cu valoarea data, pentru containerele care sunt carusel doar pe mobil.
 */
(function () {
  const SELECTOR = '[data-drag-scroll]';
  const DRAG_THRESHOLD = 4;

  function bind(el) {
    if (el.dataset.dragScrollBound) return;
    el.dataset.dragScrollBound = '1';

    let down = false;
    let dragging = false;
    let startX = 0;
    let startScroll = 0;

    const active = () => {
      const until = parseInt(el.dataset.dragScrollUntil, 10);
      if (!until) return true;
      return window.innerWidth <= until;
    };

    el.addEventListener('pointerdown', (e) => {
      if (e.pointerType !== 'mouse' || !active()) return;
      down = true;
      dragging = false;
      startX = e.clientX;
      startScroll = el.scrollLeft;
    });

    el.addEventListener('pointermove', (e) => {
      if (!down) return;
      const dx = e.clientX - startX;

      // Capture-ul se ia abia cand tragerea incepe. Luat pe pointerdown,
      // browserul retargeteaza click-ul catre container si linkurile din
      // carduri nu mai pot fi apasate.
      if (!dragging) {
        if (Math.abs(dx) <= DRAG_THRESHOLD) return;
        dragging = true;
        el.classList.add('is-dragging');
        try {
          el.setPointerCapture(e.pointerId);
        } catch (err) {
          /* pointer deja eliberat; tragerea merge si fara capture */
        }
      }

      el.scrollLeft = startScroll - dx;
    });

    const end = () => {
      if (!down) return;
      down = false;
      el.classList.remove('is-dragging');
    };
    el.addEventListener('pointerup', end);
    el.addEventListener('pointercancel', end);
    el.addEventListener('pointerleave', end);

    // Dupa o tragere, click-ul de pe cardul de sub cursor nu trebuie sa se declanseze.
    el.addEventListener(
      'click',
      (e) => {
        if (dragging) {
          e.preventDefault();
          e.stopPropagation();
        }
        dragging = false;
      },
      true
    );
  }

  function init(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Theme editor: sectiunile pot fi re-randate fara reload.
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
